module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/tabination/pill-group/pill-group.component.scss
// module id = ./src/app/features/tabination/pill-group/pill-group.component.scss
// module chunks = main